import { useFeatureAccountRequestInfoPageQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

import { IUseFeatureAccountRequestInfoPage } from './types';

export const useFeatureAccountRequestInfoPage = (): IUseFeatureAccountRequestInfoPage => {
  const { featureAccountRequestInfoPageId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureAccountRequestInfoPageQuery({
    variables: { featureAccountRequestInfoPageId },
    skip: !featureAccountRequestInfoPageId,
  });

  const featureAccountRequestInfoPage = data?.FeatureAccountRequestInfoPage ?? null;
  const featureAccountRequestInfoPageLoading = featureIdsLoading || loading;

  return { featureAccountRequestInfoPageLoading, featureAccountRequestInfoPage };
};
